import React, { useContext } from "react";
import { Col, Row } from "reactstrap";
import Avatar from "../../assets/images/icon/placeholder_Awatar.png";
import { _imagesURL } from "../../constants/API";
import ImageComponent from "../common/ImageComponent";
import { RiEditLine } from "react-icons/ri";
import { CiCamera } from "react-icons/ci";
import { GoDeviceCameraVideo } from "react-icons/go";
import CreatePostPopup from "./CreatePostPopup";
import ProgressPopup from "./postTabs/ProgressPopup";
import InviteWebinarPopup from "./postTabs/InviteWebinarPopup";
import ClinicalSessionInvitePopup from "./postTabs/ClinicalSessionInvitePopup";
import usePostForm from "../../hooks/home/usePostForm";
import { PostDetailContext } from "../../App";

const PostForm = ({
  lang,
  splashData,
  selectedLabel,
  titleMessage,
  inviteWebinar,
  inviteClinical,
  showProgress,
  progress,
  webinarId,
  clinicalId,
  pages,
  setInviteWebinar,
  setInviteClinical,
  setProgress,
  handleApiCall,
  handleLabelClick,
  handleFormClick,
  handlePublishClick,
  selectedPost,
  editWebinar,
  setEditWebinar,
  showPost,
  setShowPost,
  refetch,
  handlePostSelect
}) => {
    const { isOpen } = useContext(PostDetailContext);
  return (
    <>
      <div
        className={`bg-white feed-form-shadow rounded postform-container scroll-hide cursor ${isOpen && editWebinar&& "d-none"}`}
        onClick={handleFormClick}
        onKeyDown={(e) => e.key === "Enter" && handleFormClick()}
        role="button"
        tabIndex={0}
        aria-label="Open post form"
      >
        <div className="d-flex">
          <div className="d-flex align-items-center gap-2 mx-3">
            <RiEditLine size={16} />
            <p className="roboto-medium fs-14 mb-0">{lang.publish}</p>
          </div>
          <div
            className="d-flex custom-border-box"
          >
            {pages.map((val, i) => (
              <div
                className="d-flex align-items-center gap-2 p-3"
                key={i}
                onClick={() => handleLabelClick(val.label)}
                onKeyDown={(e) => e.key === "Enter" && handleLabelClick(val.label)}
                role="button"
                tabIndex={0}
                aria-label={`Select ${val.label}`}
              >
                <img src={val.src} width={16} height={16} alt={val.label} />
                <p
                  className="roboto-regular fs-14 mb-0 text-gray-post"
                  
                >
                  {val.label}
                </p>
              </div>
            ))}
          </div>
        </div>
        <Row className="py-2 px-3">
          <Col className="d-flex">
            <div>
              <div
                className="rounded-circle border-cyan-box"
              >
                <ImageComponent
                  src={
                    splashData && splashData.user && splashData.user.image !== ""
                      ? _imagesURL + splashData.user.image
                      : Avatar
                  }
                  compClassName="rounded-circle"
                  loader_height="44px"
                  loader_width="44px"
                  img_height="44px"
                  img_width="44px"
                  roundShimmerSize={44}
                />
              </div>
            </div>
            <div className="w-100 align-self-center">
              <textarea
                className="form-control border-0 cursor fs-md-14 no-interaction"
                placeholder={lang?.post_form_placeholder}
                rows="1"
                onClick={handlePublishClick}
                
                aria-label="Post input placeholder"
              />
            </div>
          </Col>
        </Row>
        <div
          className="d-flex align-items-center border-top-cyan"
         
        >
          <button
            className="d-flex align-items-center gap-2 rounded-pill border-0 px-3 py-1 m-2 bg-light-gray"
            onClick={handlePublishClick}
            aria-label="Add images"
          >
            <CiCamera size={16} color="rgba(132, 135, 152, 1)" />
            <p
              className="roboto-regular fs-14 mb-0 text-gray-post-btn-shade"
             
            >
              {lang.images}
            </p>
          </button>
          <button
            className="d-flex align-items-center gap-2 rounded-pill border-0 px-3 py-1 mx-2 bg-light-gray"
            onClick={handlePublishClick}
            aria-label="Add videos"
          >
            <GoDeviceCameraVideo size={16} className="text-gray-post-btn-shade" />
            <p
              className="roboto-regular fs-14 mb-0 text-gray-post-btn-shade"
            >
              {lang.videos}
            </p>
          </button>
        </div>
      </div>
      {showPost && (
        <CreatePostPopup
          selectedLabel={selectedLabel}
          refetch={refetch}
          selectedPost={selectedPost}
          editWebinar={editWebinar}
          setEditWebinar={setEditWebinar}
          show={showPost}
          onHide={() => setShowPost(false)}
          setProgress={setProgress}
          handleApiCall={handleApiCall}
          handlePostSelect={handlePostSelect}
        />
      )}
      {showProgress && (
        <ProgressPopup
          title={titleMessage}
          message={lang.uploading_in_progress}
          progress={progress}
          isVisible={showProgress}
        />
      )}
      {inviteWebinar && (
        <InviteWebinarPopup
          isOpen={inviteWebinar}
          webinarId={webinarId}
          toggleModal={() => setInviteWebinar(!inviteWebinar)}
        />
      )}
      {inviteClinical && (
        <ClinicalSessionInvitePopup
          isOpen={inviteClinical}
          toggleModal={() => setInviteClinical(!inviteClinical)}
          clinicalId={clinicalId}
        />
      )}
    </>
  );
};
const MemoizedPostForm = React.memo(PostForm);

// Wrapper Component
const PostFormWrapper = (props) => {
  const postFormProps = usePostForm(props);
  return <MemoizedPostForm {...postFormProps} />;
};
export default PostFormWrapper;